import {apiFetch} from "../../api";
import {BASE_URL as u} from "../../../commonUrls";

const BASE_URL = `${u}/merchant`;
//const USER_ID = "u-c136202b-94f4-4e51-aa0b-72db0503c362";

export async function getAllMerchants(){
  const res = await apiFetch(`${BASE_URL}/byUserId`);
  return res.json();
}

export async function createMerchant(merchantName, merchantType){
  const payload = { userId: 0, merchantName, merchantType, active: true };

  const res = await apiFetch(`${BASE_URL}`,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(payload)
  });

  return res.json();
}

export async function deleteMerchant(id){
  await apiFetch(`${BASE_URL}/${id}`,{ method:"DELETE" });
}

export async function updateMerchant(id, merchantName, merchantType, active){
  const payload = { userId: 0, merchantName, merchantType, active };

  const res = await apiFetch(`${BASE_URL}/${id}`,{
    method:"PUT",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(payload)
  });

  return res.json();
}
